var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"ComponentDestinationListInput"}},[_c('label',{attrs:{"for":"DestinationListInput"}},[_vm._v("送信先リスト名")]),_c('BaseTextBox',{staticClass:"destination-list-input-container",attrs:{"textBoxID":"DestinationListInput","value":_vm.selectedValue,"error":_vm.error},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }